import { PrivateApi } from "./api_gateway";

export const createBoard = (board) => {
  return PrivateApi.post("/boards/create", board);
};
